import api from '../services/api';

const cache = new Map();
const inflight = new Map();

const buildCacheKey = (key, { status, assetType } = {}) =>
  `${key}|${status ?? ''}|${assetType ?? ''}`;

/**
 * Fetch a presigned URL, deduplicating concurrent requests and caching results
 * until shortly before expiry.
 */
export const getPresignedUrl = async (key, { status, assetType } = {}) => {
  if (!key) return null;

  const cacheKey = buildCacheKey(key, { status, assetType });
  const cached = cache.get(cacheKey);

  if (cached && cached.expiresAt > Date.now()) {
    return cached.url;
  }

  if (inflight.has(cacheKey)) {
    return inflight.get(cacheKey);
  }

  const request = api
    .get('/api/media/presign', {
      params: { url: key, status, assetType },
    })
    .then(({ data }) => {
      const url = data.presignedUrl || null;

      if (url) {
        const ttlMs = Math.max((data.expiresIn || 3600) - 60, 60) * 1000;
        cache.set(cacheKey, {
          url,
          expiresAt: Date.now() + ttlMs,
        });
      }

      inflight.delete(cacheKey);
      return url;
    })
    .catch((error) => {
      inflight.delete(cacheKey);
      throw error;
    });

  inflight.set(cacheKey, request);
  return request;
};
